/**
 * Filtros del listado de secuencias de checklists ("Secuencias", VEC-3474), para `GridFilterPanel`: nombre, estado al que aplica
 * y el switch "Ver Inactivos" (apagado por defecto: solo las activas), como en el resto de las grillas. Son pocas filas por cliente, así que se
 * filtran en el navegador (`filtrarSecuencias`), sin tocar la API.
 */

export const SECUENCIAS_FILTROS_STORAGE_KEY = 'SecuenciasChecklistGrid_filtros';

const ANCHO = { xs: 12, sm: 6, md: 3, lg: 3 };

export const buildSecuenciasFilterFields = () => [
	{
		name: 'nombre',
		type: 'text',
		messageId: 'secuenciasFiltros.nombre.label',
		label: 'Nombre',
		size: ANCHO,
	},
	{
		name: 'estado',
		type: 'multiselect',
		messageId: 'secuenciasFiltros.estado.label',
		label: 'Aplica a vehículos en estado',
		size: ANCHO,
	},
	{
		// Un `check` va en la fila del botón Buscar y aplica al instante. Mismo texto que el "Ver Inactivos" de la grilla de checklists.
		name: 'verInactivos',
		type: 'check',
		messageId: 'formulariosGridFilters.render.filtros.ver_inactivos',
		label: 'Ver Inactivos',
	},
];

const aLista = (valor) =>
	String(valor === undefined || valor === null ? '' : valor)
		.split(',')
		.map((v) => v.trim())
		.filter((v) => v !== '');

/** ¿Hay algún filtro cargado? El switch "Ver Inactivos" no cuenta como búsqueda. */
export const hayFiltros = (query) => {
	const q = query || {};
	return String(q.nombre || '').trim() !== '' || aLista(q.estado).length > 0;
};

/**
 * Aplica en el navegador lo que entrega el panel: `nombre` contiene (sin distinguir mayúsculas), `estado` es una lista de estados de origen y
 * `verInactivos` ('1' prendido): apagado deja solo las activas, prendido muestra todas.
 */
export const filtrarSecuencias = (secuencias, query) => {
	const q = query || {};
	const nombre = String(q.nombre || '').trim().toLowerCase();
	const estados = aLista(q.estado);
	const verInactivos = q.verInactivos === '1';

	return (secuencias || []).filter((s) => {
		if (!verInactivos && !s.activo) return false;
		if (nombre !== '' && String(s.nombre || '').toLowerCase().indexOf(nombre) === -1) return false;
		if (estados.length > 0 && estados.indexOf(s.movil_estado_origen) === -1) return false;
		return true;
	});
};
